import React, { Component } from 'react';
import mobileVerify from '../../verification/mobile-verify.js';

class AccountSettingsMobileVerified extends Component {
	componentWillMount() {
		mobileVerify().open('success');
	}

	render() {
		return (
			<div id="account-verify-mobile-verified" />
		);
	}
}

export default AccountSettingsMobileVerified;




// WEBPACK FOOTER //
// ./mobile-core/src/components/account/account-settings-mobile-verified.js